var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSpeechtopiaBook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 8.5 8.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3 5.7H1.2a.3.3 0 00-.3.3v1a.3.3 0 00.3.3h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7 5.7v1l.4-.2.4.2v-1M1.3 3.4h6.1a.3.3 0 01.3.3v1a.3.3 0 01-.3.3h-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9 3.4v1.1l-.4-.3-.4.3v-1M7.3 1.2H1.2a.3.3 0 00-.3.3v1a.3.3 0 00.3.3h6"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpeechtopiaBook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/speechtopia-book.3e39843a.svg";
export { ForwardRef as ReactComponent };